<script>
import {
  ADD_POSITIVE_TICKET_NAME,
  ADD_NEGATIVE_TICKET_NAME,
} from '@app/Staff/Ticket/routes'

export default {
  name: 'TicketLinksController',

  render() {
    return this.$scopedSlots.default({
      positiveTicketUrl: this.$router.resolve({ name: ADD_POSITIVE_TICKET_NAME }).href,
      negativeTicketUrl: this.$router.resolve({ name: ADD_NEGATIVE_TICKET_NAME }).href,
    })
  },
}
</script>
